export const lan = {
  add_table: "address_reser_table",
};

export default lan;
